/**
 * Frame Rate cell on the Site About and Edit Camera rows.
 *
 * `native_frame_rate` from `camera/{id}/status/` is plain frames per second:
 * the RTSP pullers store frames / seconds, AI Link stores the clip's fps, and
 * the health report and V1 show it unscaled. Round to two decimals and show
 * "N/A" until the camera has been sampled.
 *
 * The previous rendering was `roundToHundredth(value / 100)`, which only
 * looked like a unit conversion: `roundToHundredth` multiplies by 100 (it
 * turns a 0–1 fraction into a percentage), so the two cancelled out. This
 * helper says the same thing without the detour (ENG-2123).
 */
export const formatFrameRate = (value: unknown): number | "N/A" => {
  const fps = Number(value);
  if (!fps || !Number.isFinite(fps)) return "N/A";
  return Number(fps.toFixed(2));
};
